"use client";

import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { CLIENT_API_ROUTES } from "@/utils/clientApiRoutes";
import { useEffect, useState } from "react";
import axios from "axios";
import { RxCross2 } from "react-icons/rx";
import { FaExternalLinkAlt } from "react-icons/fa";

function Headline({ hasHeadline, setHasHeadline }) {
  const [headlines, setHeadlines] = useState([]);

  const fetchData = async () => {
    try {
      const response = await axios.get(CLIENT_API_ROUTES?.GET_HEADLINES);

      const headlines = response?.data?.headlines || [];
      setHeadlines(headlines);
      if (headlines?.length > 0) {
        setHasHeadline(true);
      }
    } catch (err) {
      console.error("Error Fetching headlines:", err?.message);
      setHeadlines([]);
      setHasHeadline(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  if (headlines?.length > 0 && hasHeadline) {
    return (
      <div className="h-[3.5rem] animate-flip-down flex justify-end items-center gap-2 md:gap-4 w-full  bg-primary">
        <div className="w-[95%] max-w-5xl text-white/90 font-medium mx-auto">
          <div className="">
            <Carousel
              swipeable={true}
              draggable={true}
              showDots={true}
              responsive={{
                one: {
                  breakpoint: { max: 4000, min: 0 },
                  items: 1,
                },
              }}
              infinite={true}
              autoPlay={true}
              arrows={false}
              autoPlaySpeed={3500}
              keyBoardControl={true}
              customTransition="transform 400ms ease-in-out"
              // customTransition="all .5"
              transitionDuration={0}
              containerClass="headline-carousel pb-2 w-full h-full"
              dotListClass="custom-dot-list-style"
              itemClass="carousel-item-padding-40-px"
              pauseOnHover={true}
            >
              {headlines.map((item, i) => (
                <div
                  key={i}
                  className="w-[80%] md:mr-10 mx-auto flex gap-2 px-2"
                >
                  <p className=" text text-sm md:text-[15px] line-clamp-2">
                    {item?.headline}
                  </p>
                  {item?.link && (
                    <a
                      href={item?.link}
                      target="_blank"
                      className="mt-1 w-[5%]"
                    >
                      <FaExternalLinkAlt className=" text-sm" />
                    </a>
                  )}
                </div>
              ))}
            </Carousel>
          </div>
        </div>
        <div className="w-[8%] flex justify-center mt-[-14px] mr-2">
          <RxCross2
            onClick={() => setHasHeadline(false)}
            className="cursor-pointer text-white text-xl"
          />
        </div>
      </div>
    );
  }
}

export default Headline;
